import { render, staticRenderFns } from "./AttchmentList.vue?vue&type=template&id=637665f2&scoped=true&"
import script from "./AttchmentList.vue?vue&type=script&lang=js&"
export * from "./AttchmentList.vue?vue&type=script&lang=js&"
import style0 from "./AttchmentList.vue?vue&type=style&index=0&id=637665f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637665f2",
  null
  
)

export default component.exports